module.exports = __webpack_public_path__ + "img/symbol_correct.45998201.png";